// extracted by mini-css-extract-plugin
module.exports = {"modal":"menu_modal__1nR-0","menu":"menu_menu__2puF1","user":"menu_user__3eJG1","closeBtn":"menu_closeBtn__tFgGj","logo":"menu_logo__2CI4n"};